import axios from "axios";
import { SagaIterator } from "redux-saga";
import { call, cancelled, put, takeLatest } from "redux-saga/effects";

import { callGet } from "../../http_client";
import { createGenerateReportHandler } from "../reports/sagas";

import {
  hostsChartFetchError,
  hostsChartFetchRequest,
  hostsChartFetchSuccess,
  hostsFetchError,
  hostsFetchRequest,
  hostsFetchSuccess,
  hostsSummaryFetchError,
  hostsSummaryFetchRequest,
  hostsSummaryFetchSuccess,
  reportGeneratorTaskCreateRequest,
} from "./actions";
import { HostsActionTypes } from "./types";

export function* handleHostsFetch(action: ReturnType<typeof hostsFetchRequest>): SagaIterator {
  const source = axios.CancelToken.source();
  try {
    const { from, to, market, page, pageSize, platform, ordering, gateId, resolution } = action.payload;
    const res = yield call(
      callGet,
      "/hosts/",
      {
        from,
        to,
        market,
        page,
        pageSize,
        platform,
        ordering,
        gateId,
        resolution,
      },
      source.token
    );
    yield put(hostsFetchSuccess(res.data));
  } catch (err) {
    yield put(hostsFetchError(err.message));
  } finally {
    if (yield cancelled()) {
      source.cancel();
    }
  }
}

export function* handleHostsSummaryFetch(action: ReturnType<typeof hostsSummaryFetchRequest>): SagaIterator {
  const source = axios.CancelToken.source();
  try {
    const { from, to, market, platform, gateId } = action.payload;
    const res = yield call(callGet, "/hosts/summary/", { from, to, market, platform, gateId }, source.token);
    yield put(hostsSummaryFetchSuccess(res.data));
  } catch (err) {
    yield put(hostsSummaryFetchError(err.message));
  } finally {
    if (yield cancelled()) {
      source.cancel();
    }
  }
}

export function* handleHostsChartFetch(action: ReturnType<typeof hostsChartFetchRequest>): SagaIterator {
  const source = axios.CancelToken.source();
  try {
    const { from, to, market, metric, gateId, resolution } = action.payload;
    const res = yield call(callGet, "/hosts/chart/", { from, to, market, metric, gateId, resolution }, source.token);
    yield put(hostsChartFetchSuccess({ items: res.data }));
  } catch (err) {
    yield put(hostsChartFetchError(err.message));
  } finally {
    if (yield cancelled()) {
      source.cancel();
    }
  }
}

const handleHostsReportFetch = createGenerateReportHandler<ReturnType<typeof reportGeneratorTaskCreateRequest>>(
  "/hosts/report/"
);

function* watchHostsSagas(): SagaIterator {
  yield takeLatest(HostsActionTypes.DATA_FETCH_REQUEST, handleHostsFetch);
  yield takeLatest(HostsActionTypes.SUMMARY_FETCH_REQUEST, handleHostsSummaryFetch);
  yield takeLatest(HostsActionTypes.CHART_DATA_FETCH_REQUEST, handleHostsChartFetch);
  yield takeLatest(HostsActionTypes.GENERATE_REPORT_REQUEST, handleHostsReportFetch);
}

export default watchHostsSagas;
